import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface PaymentStatusState {
    paymentStatus: PaymentStatus
}

interface PaymentStatus {
    ActionName:string;
    Amount:number;
    Status:string;
    
}



const initialState: PaymentStatusState = {
    paymentStatus : {
    ActionName:"",
    Amount:0,
    Status:"",
 
  } 
} 



export const paymentStatusSlice  = createSlice({
    name: 'paymentStatus',
    initialState,
    reducers: {
        updatePaymentStatus: (state, action: PayloadAction<PaymentStatus>) => {
            state.paymentStatus = action.payload;
        }
    }
});
 
export const {updatePaymentStatus} = paymentStatusSlice.actions;

export default paymentStatusSlice.reducer;